module.exports = __webpack_public_path__ + "static/media/img91.68292e6b.jpg";